<template>
  <div>
    <div v-if="!user.grant.dashboard">
      <div class="h-screen flex w-full bg-img">
        <div
          class="
            vx-col
            flex
            items-center
            justify-center
            flex-col
            sm:w-1/2
            md:w-3/5
            lg:w-3/4
            xl:w-1/2
            mx-auto
            text-center
          "
        >
          <img
            src="@/assets/images/pages/404.png"
            alt="graphic-404"
            class="mx-auto mb-4 max-w-full"
          />
          <h1 class="sm:mx-0 mx-4 mb-12 text-3xl d-theme-heading-color">
            404 - Page introuvable!
          </h1>
          <p class="sm:mx-0 mx-4 mb-4 sm:mb-16 d-theme-heading-color">
            La page que vous demandez est introuvable
          </p>
        </div>
      </div>
    </div>
    <div v-else>
      <div class="stat_bloc">
        <div class="g-consultation">
          <div class="panel_cons">
            <div class="panel_cons__text">
              <p class="bold">{{ model.new }}</p>
              <p>Nouvelle consultation</p>
            </div>
            <div class="panel_cons__icon">
              <svg
                width="46"
                height="46"
                viewBox="0 0 46 46"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <circle cx="23" cy="23" r="23" fill="#E5E5E5" />
                <path
                  d="M23 33C28.5228 33 33 28.5228 33 23C33 17.4772 28.5228 13 23 13C17.4772 13 13 17.4772 13 23C13 28.5228 17.4772 33 23 33Z"
                  stroke="black"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M26 20L20 26"
                  stroke="black"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
            </div>
          </div>
          <div class="panel_cons">
            <div class="panel_cons__text">
              <p class="bold">{{ model.expiredTreeDay }}</p>
              <p>Consultation non validée et expirée après 3jrs</p>
            </div>
            <div class="panel_cons__icon">
              <svg
                width="46"
                height="46"
                viewBox="0 0 46 46"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <circle
                  cx="23"
                  cy="23"
                  r="23"
                  fill="#28C76F"
                  fill-opacity="0.12"
                />
                <path
                  d="M33 22.08V23C32.9988 25.1564 32.3005 27.2547 31.0093 28.9818C29.7182 30.709 27.9033 31.9725 25.8354 32.5839C23.7674 33.1953 21.5573 33.1219 19.5345 32.3746C17.5117 31.6273 15.7847 30.2461 14.611 28.4371C13.4373 26.628 12.8798 24.4881 13.0217 22.3363C13.1636 20.1846 13.9972 18.1363 15.3983 16.4971C16.7994 14.8578 18.6928 13.7154 20.7962 13.2401C22.8996 12.7649 25.1003 12.9823 27.07 13.86"
                  stroke="#28C76F"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M33 15L23 25.01L20 22.01"
                  stroke="#28C76F"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
            </div>
          </div>
        </div>
        <div class="g-consultation">
          <div class="panel_cons">
            <div class="panel_cons__text">
              <p class="bold">{{ model.validate }}</p>
              <p>Consultation validée et expirée après 14 jrs</p>
            </div>
            <div class="panel_cons__icon">
              <svg
                width="46"
                height="46"
                viewBox="0 0 46 46"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <circle
                  cx="23"
                  cy="23"
                  r="23"
                  fill="#28C76F"
                  fill-opacity="0.12"
                />
                <path
                  d="M33 22.08V23C32.9988 25.1564 32.3005 27.2547 31.0093 28.9818C29.7182 30.709 27.9033 31.9725 25.8354 32.5839C23.7674 33.1953 21.5573 33.1219 19.5345 32.3746C17.5117 31.6273 15.7847 30.2461 14.611 28.4371C13.4373 26.628 12.8798 24.4881 13.0217 22.3363C13.1636 20.1846 13.9972 18.1363 15.3983 16.4971C16.7994 14.8578 18.6928 13.7154 20.7962 13.2401C22.8996 12.7649 25.1003 12.9823 27.07 13.86"
                  stroke="#28C76F"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M33 15L23 25.01L20 22.01"
                  stroke="#28C76F"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
            </div>
          </div>
          <div class="panel_cons">
            <div class="panel_cons__text">
              <p class="bold">{{ model.canceled }}</p>
              <p>Consultation annulée</p>
            </div>
            <div class="panel_cons__icon">
              <svg
                width="46"
                height="46"
                viewBox="0 0 46 46"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <circle
                  cx="23"
                  cy="23"
                  r="23"
                  fill="#FF4961"
                  fill-opacity="0.12"
                />
                <path
                  d="M23 33C28.5228 33 33 28.5228 33 23C33 17.4772 28.5228 13 23 13C17.4772 13 13 17.4772 13 23C13 28.5228 17.4772 33 23 33Z"
                  stroke="#FF4961"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M26 20L20 26"
                  stroke="#FF4961"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M20 20L26 26"
                  stroke="#FF4961"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
            </div>
          </div>
        </div>
        <div class="panel_collect">
          <div class="total">
            <div style="font-size: 20px; color: #000">
              Montant total collecté
            </div>
            <div style="font-size: 30px; color: #000">
              {{ formatAmount(model.amount) }}
            </div>
          </div>
          <div class="operateur">
            <div style="font-size: 22px; color: #000">
              <span style="color: #ffe802">-</span> MTN :
              {{ formatAmount(model.mtn) }}
            </div>
            <div style="font-size: 22px; color: #000">
              <span style="color: green">-</span> MOOV :
              {{ formatAmount(model.moov) }}
            </div>
            <div style="font-size: 22px; color: #000">
              <span style="color: #2a29b3">-</span> SBIN :
              {{ formatAmount(model.sbin) }}
            </div>
          </div>
        </div>
      </div>
      <div class="graph_section">
        <div class="donut">
          <apexchart
            height="330"
            v-if="!loading_d"
            type="donut"
            :options="donus.chartOptions"
            :series="donus.series"
          ></apexchart>
        </div>
        <div class="month">
          <div class="export_graph">
            <vs-button
              @click="exportData"
              size="small"
              v-if="!loading_m"
              color="primary"
              type="filled"
              >Exporter</vs-button
            >
          </div>
          <apexchart
            type="bar"
            v-if="!loading_m"
            height="350"
            :options="month.chartOptions"
            :series="month.series"
          ></apexchart>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { format } from "../helper/helper";
import apexchart from "vue-apexcharts";
export default {
  components: {
    apexchart,
  },
  data: () => ({
    loading_d: false,
    loading_m: false,
    model: {
      new: 0,
      validate: 0,
      canceled: 0,
      expiredTreeDay: 0,
      amount: 0,
      moov: 0,
      mtn: 0,
      sbin: 0
    },
    user: {},
    donus: {
      series: [],
      chartOptions: {
        chart: {
          type: "donut",
        },
        legend: {
          show: true,
          position: "bottom",
          horizontalAlign: "center",
        },
        title: {
          text: "Top 10 des spécialités",
          align: "left",
        },
        responsive: [
          {
            breakpoint: 480,
          },
        ],
        labels: [],
      },
    },
    month: {
      series: [
        {
          name: "Total Paiements",
          data: [],
        },
      ],
      chartOptions: {
        chart: {
          type: "bar",
          height: 200,
        },
        title: {
          text: "Ciffre d'affaire par mois",
          align: "left",
        },
        plotOptions: {
          bar: {
            horizontal: false,
            columnWidth: "20%",
            //endingShape: 'rounded'
          },
        },
        theme: {
          monochrome: {
            enabled: true,
            color: "#003061",
          },
        },
        dataLabels: {
          enabled: false,
        },
        stroke: {
          show: true,
          width: 2,
          colors: ["transparent"],
        },
        xaxis: {
          categories: [
            "Jan",
            "Feb",
            "Mar",
            "Apr",
            "May",
            "Jun",
            "Jul",
            "Aug",
            "Sep",
            "Oct",
            "Nov",
            "Dec",
          ],
        },
        yaxis: {
          title: {
            text: "Montants payés",
          },
        },
        fill: {
          opacity: 1,
        },
        /*tooltip: {
            y: {
                formatter: function (val) {
                    return ""
                }
            }
        }*/
      },
    },
  }),
  created() {
    this.user = JSON.parse(localStorage.getItem("user_cnhu"));
  },
  mounted() {
    if (this.user.grant.dashboard) {
      this.getData();
      this.getDonut();
      this.getMonth();
    }
  },
  methods: {
    exportData() {
      this.$vs.loading();
      this.$http
        .post(
          "/dashboard/stats/specialities",
          {},
          {
            responseType: "blob",
          }
        )
        .then((response) => {
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement("a");
          link.href = link.href = url;
          link.setAttribute("download", "chiffre_daffaire.xlsx");
          document.body.appendChild(link);
          link.click();
          this.$vs.loading.close();
        })
        .catch((error) => {
          this.$vs.loading.close();
          if (error.response.status === 401) {
            this.$vs.notify({
              title: "Erreur",
              text: "Votre session a expiré",
              color: "danger",
              iconPack: "feather",
              icon: "icon-check",
              position: "top-right",
            });
            this.$router.push({ name: "page-login" });
          }
        });
    },
    getData() {
      this.$vs.loading();
      this.$http
        .get("/dashboard/stats")
        .then((response) => {
          this.model = response.data;
          this.$vs.loading.close();
        })
        .catch((error) => {
          this.$vs.loading.close();
          if (error.response.status === 401) {
            this.$vs.notify({
              title: "Erreur",
              text: "Votre session a expiré",
              color: "danger",
              iconPack: "feather",
              icon: "icon-check",
              position: "top-right",
            });
            this.$router.push({ name: "page-login" });
          }
        });
    },
    getDonut() {
      this.loading_d = true;
      this.$http
        .get("/dashboard/stats/top")
        .then((response) => {
          this.donus.series = response.data.series;
          this.donus.chartOptions.labels = response.data.labels;
          this.loading_d = false;
        })
        .catch((error) => {
          this.loading_d = false;
          console.log(error);
        });
    },
    getMonth() {
      this.loading_m = true;
      this.$http
        .get("/dashboard/stats/specialities")
        .then((response) => {
          this.month.series = response.data;
          this.loading_m = false;
        })
        .catch((error) => {
          this.loading_m = false;
          console.log(error);
        });
    },
    formatAmount(amount) {
      if (amount) {
        return format(amount) + " Fcfa";
      } else {
        return amount + " Fcfa";
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.stat_bloc {
  display: grid;
  grid-template-columns: 1fr 1fr 2fr;
  grid-gap: 20px;
}
.panel_new {
  background: #ffffff;
  border-radius: 6px;
  padding: 10px;
  height: 268px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
}
.bold {
  font-weight: bold;
  font-size: 20px;
}
.panel_cons {
  height: 125px;
  background: #ffffff;
  border-radius: 6px;
  padding: 10px;
  display: grid;
  justify-content: center;
  align-items: center;
  grid-template-columns: 1fr 1fr;
  .panel_cons__icon {
    place-self: center;
  }
}
.g-consultation {
  display: grid;
  grid-template-columns: 1fr;
  grid-gap: 20px;
}
.panel_collect {
  height: 274px;
  background: #ffffff;
  border-radius: 6px;
  padding: 20px;
  .total {
    height: 117px;
    border-bottom: 1px solid #ebe9f1;
  }
}
.operateur {
  margin-top: 30px;
}
@media only screen and (max-width: 660px) {
  .stat_bloc {
    display: grid !important;
    grid-template-columns: 1fr !important;
    grid-auto-flow: row !important;
    grid-gap: 20px !important;
  }
  .graph_section {
    margin-top: 20px !important;
    display: grid !important;
    grid-template-columns: 1fr !important;
    grid-auto-flow: row !important;
    grid-gap: 20px !important;
  }
}
.graph_section {
  margin-top: 20px;
  display: grid;
  grid-template-columns: 3fr 5fr;
  grid-gap: 20px;
}
.donut {
  min-height: 274px;
  height: auto;
  background: #ffffff;
  border-radius: 6px;
  padding: 20px;
}
.month {
  min-height: 274px;
  height: auto;
  background: #ffffff;
  border-radius: 6px;
  padding: 20px;
}
.export_graph {
  display: flex;
  justify-content: flex-end;
}
</style>
